import React from 'react';
import DefaultMediaFallback from './DefaultMediaFallback';

/**
 * Renders the entry image experience.
 *
 * @param {object} props - Component properties.
 * @param {*} props.src - src value.
 * @param {*} props.className - class name value.
 * @param {*} props.fallbackType - fallback type value.
 * @param {*} props.variant - variant value.
 * @returns {JSX.Element} The rendered interface.
 */
export default function EntryImage({
  src,
  className = 'entry-card-photo',
  fallbackType = 'hobby',
  variant = 'thumbnail-square',
}) {
  const variantClassName = variant ? `entry-media entry-media--${variant}` : '';
  if (src) return <img className={`${className} ${variantClassName}`.trim()} src={src} alt="" />;

  return <DefaultMediaFallback className={className} fallbackType={fallbackType} variant={variant} />;
}
